<!--<tandem-card class="w-full" *ngIf="tableConfig">-->
  <tandem-table *ngIf="tableConfig" class="w-full" [tableConfiguration]="tableConfig" [data]="tableData"></tandem-table>
<!--</tandem-card>-->
